import React from 'react';

import './styles.css';
import { withLanguageContext } from '../../../utils/LanguageContext';
import { TextImage } from '../../templates';

type Props = {
    content: {
        solutionsPage: {
            docBuilderApp: {
                buttonLabel: string;
                content: string;
                heading: string;
                href: string;
				target: string;
				imageToRight: boolean;
            }
        }
    }
};

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} [example]
 *
 * @augments {Component<Props>}
 */
const DocBuilderAppView: React.FC<Props> = (props: Props) => {
		const {
		content,
		heading,
		imageToRight,
		buttonLabel,
		href,
		target
	} = props.content.solutionsPage.docBuilderApp;

	return (
		<TextImage
			{...{
				content,
				heading,
				imageToRight,
				buttonLabel,
				href,
				target,
			}}
			imageClassName='DocBuilderImage'
			className='DocBuilderAppView'
		/>
	);

};

export default withLanguageContext(DocBuilderAppView);
